import styled from 'styled-components';

export const StyledOfferCardsDivPreviewMode = styled.div<{ isMBEpreview?: boolean }>`
  /* Disable pointer events only if isMBE is NOT true */
  ${props => !props.isMBEpreview && 'pointer-events: none;'}

  .glide__arrow--right {
    display: none;
  }
  .center-align {
    display: none !important;
  }
`;
